/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket?: Socket;
  private url = environment.socket_url;
  private nsp = '/';
  private path = '/socket.io';
  constructor() {}

  initSocket(): void {
    const token = sessionStorage.getItem(environment.storageKey);

    if (!token) {
      console.warn('No token found, socket will not connect.');
      return;
    }
    const opts = {
      path: this.path,
      transports: ['websocket', 'polling'],
      withCredentials: false,
      query: { token },
      timeout: 10000,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      extraHeaders: {
        // example: add debug headers if needed
        // 'X-Debug': '1'
      }
    };

    // build namespace URL
    const connectUrl = this.url + (this.nsp === '/' ? '' : this.nsp);

    this.socket = io(connectUrl, opts);

    this.bindSocketEvents();
  }

  private bindSocketEvents(): void {
    if (!this.socket) return;

    this.socket.on('connect', () => {
      console.log(
        `connected [id=${this.socket?.id}] via ${this.socket?.io.engine.transport.name}`
      );
    });

    this.socket.on('disconnect', (reason: string) => {
      console.warn(`disconnected: ${reason}`);
    });

    this.socket.io.on('reconnect_attempt', (n: number) => console.warn(`reconnect attempt ${n}…`)
    );
    this.socket.io.on('reconnect_error', (err: any) => console.error('reconnect error:', err)
    );
    this.socket.io.on('reconnect_failed', () => console.error('reconnect failed')
    );
    this.socket.on('connect_error', (e: any) => {
      console.error(`connect_error: ${e?.message || e}`);
    });
    this.socket.on('error', (e: any) => console.error('socket error:', e));

    // App-specific listeners
    this.socket.on('msg', (payload: any) => {
      console.log('msg event:', payload);
    });
    this.socket.on('pong', (ms: number) => {
      console.log(`latency: ${ms}ms`);
    });
  }

  emitAction(
    event: string,
    payload?: any,
    callback?: (ack: any) => void
  ): void {
    if (!this.socket) return;
    this.socket.emit(event, payload, callback);
  }

  joinRoom(room: string, callback?: (ack: any) => void): void {
    this.emitAction('join', room, callback);
  }

  leaveRoom(room: string, callback?: (ack: any) => void): void {
    this.emitAction('leave', room, callback);
  }

  sendMessage(
    room: string,
    message: string,
    callback?: (ack: any) => void
  ): void {
    this.emitAction('msg', [room, message], callback);
  }

  ping(): void {
    if (!this.socket) return;
    const t0 = performance.now();
    this.socket.timeout(3000).emit('ping', (ok = true) => {
      const dt = Math.round(performance.now() - t0);
      console.log(`ping round-trip: ${dt}ms (ok=${ok})`);
    });
  }

  onEvent<T>(event: string): Observable<T> {
    return new Observable<T>(observer => {
      this.socket?.on(event, (data: T) => observer.next(data));
    });
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined;
    }
  }
}
